import { FileText, Database, BarChart3 } from "lucide-react";

export const FileSummaryCard = ({ summary, migrationName }) => {
  if (!summary) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-gray-100 rounded-lg">
            <FileText size={20} className="text-gray-600" />
          </div>
          <div>
            <h3 className="font-medium text-gray-900">File Information</h3>
            <p className="text-sm text-gray-600">{migrationName}</p>
          </div>
        </div>

        <div className="flex items-center space-x-8">
          <div className="flex items-center space-x-2">
            <Database size={16} className="text-gray-500" />
            <span className="text-sm text-gray-600">
              <span className="font-medium text-gray-900">
                {summary.totalSourceColumns}
              </span>{" "}
              Total Columns
            </span>
          </div>

          <div className="flex items-center space-x-2">
            <BarChart3 size={16} className="text-gray-500" />
            <span className="text-sm text-gray-600">
              <span className="font-medium text-gray-900">
                {summary?.totalRows?.toLocaleString()}
              </span>{" "}
              Total Rows
            </span>
          </div>

          <div className="flex items-center space-x-3">
            <span className="text-sm font-medium text-gray-700">
              Mapping Quality:
            </span>
            <div className="flex items-center space-x-2">
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                {summary.highConfidence} High
              </span>
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                {summary.mediumConfidence} Medium
              </span>
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                {summary.lowConfidence} Low
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
